import AbstractDots from '../../assets/images/Abstract_Dots.svg'
import CSS from './styles.module.css'

// Animate on Scroll
import AOS from 'aos'
import 'aos/dist/aos.css'
import { useEffect } from 'react'

const StepsContentNeo = () => {
  useEffect(() => {
    AOS.init({ duration: 500, delay: 0 })
  }, [])

  return (
    <div className={CSS.StepsContentNeoContainer} data-aos="fade-up">
      <div className={CSS.StepsContentNeo}>
        <div className={CSS.Heading}>
          <h2>How to use Our Interview Question Generator?</h2>
        </div>
        <div className={CSS.StepsContainer}>
          <div className={CSS.StepsPipeline}></div>
          <div className={CSS.StepsContent}>
            <div className={CSS.Steps}>
              <div className={`${CSS.Content}`}>
                <div className={CSS.StepCounter}>1</div>
                <h3>Enter Job Title</h3>
                <p>
                  Simply input the job title for the position you are hiring
                  for. Our intelligent system instantly analyzes the core
                  competencies and responsibilities associated with the role to
                  generate relevant questions with answers.
                </p>
              </div>
            </div>

            <div className={CSS.Steps}>
              <div className={`${CSS.Content} ${CSS.cRight}`}>
                <div className={CSS.StepCounter}>2</div>
                <h3>
                  Choose the level of Seniority<span>(Optional)</span>
                </h3>
                <p>
                  Tailor the complexity and focus of your questions by selecting
                  the appropriate seniority level. Choose from: <br />
                  <ul style={{ marginLeft: '20px' }}>
                    <li>
                      <b> Low</b>: Ideal for entry-level positions, focusing on
                      foundational knowledge and potential.
                    </li>
                    <li>
                      <b> Medium</b>: Suited for candidates with moderate
                      experience, probing deeper into their practical skills and
                      accomplishments.
                    </li>
                    <li>
                      <b> High</b>: Designed for senior and leadership roles,
                      emphasizing extensive experience, strategic thinking, and
                      leadership capabilities.
                    </li>
                  </ul>
                </p>
              </div>
            </div>

            <div className={CSS.Steps}>
              <div className={`${CSS.Content} ${CSS.cRight}`}>
                <div className={CSS.StepCounter}>3</div>
                <h3>
                  Select Questions Type<span>(Optional)</span>
                </h3>
                <p>
                  Select from various question categories, including:
                  <ul style={{ marginLeft: '20px' }}>
                    <li>
                      <b>Technical</b>
                    </li>
                    <li>
                      <b>Behavioral</b>
                    </li>
                    <li>
                      <b>Situational</b>
                    </li>
                    <li>
                      <b>Skill based</b>
                    </li>
                    <li>
                      <b>Competency based</b>
                    </li>
                    <li>
                      <b>Fact based</b>
                    </li>
                  </ul>
                </p>
              </div>
            </div>

            <div className={CSS.Steps}>
              <div className={`${CSS.Content} ${CSS.cRight}`}>
                <div className={CSS.StepCounter}>4</div>
                <h3>
                  Break Language Barriers with Multilingual Support
                  <span>(Optional)</span>
                </h3>
                <p>
                  Our free AI Interview Questions Generator is a global tool.
                  Generate top-tier interview questions in a variety of
                  languages, including <br />
                  <b>English (US)</b>,<b> English (UK)</b>,<b> German</b>,{' '}
                  <b>French</b>,<b> Spanish</b>, <b>Arabic</b>,
                  <b> Portuguese</b>, <b>Polish</b>, and <b>Italian</b>.
                </p>
              </div>
            </div>

            <div className={CSS.Steps}>
              <div className={`${CSS.Content}`}>
                <div className={CSS.StepCounter}>5</div>
                <h3>Review and Customize</h3>
                <p>
                  This is the part where the Magic Happens. Click generate and
                  our next-gen AI engine will generate perfect interview
                  questions according to your needs. These interview questions
                  can be used to hire great candidates.
                </p>
              </div>
            </div>
          </div>
          <div className={CSS.StepsImg}>
            <img
              src={AbstractDots}
              alt="How to create a perfect Interview Questions?"
            />
          </div>
        </div>
      </div>
    </div>
  )
}

export default StepsContentNeo
